// app/javascript/controllers/currency_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['info'];

  connect() {
    this.select = this.element.querySelector('select');
    if (this.select) this.update({ target: this.select });
  }

  update(event) {
    const select = event.target;
    const option = select.selectedOptions[0];
    if (!option) return;

    const rate = option.dataset.conversionRate;
    const code = option.dataset.currencyCode;

    if (rate && code != 'EUR') {
      this.infoTarget.innerHTML = `<b>*1 EUR = </b>${rate} ${code}`;
      this.infoTarget.classList.remove('d-none');
    } else {
      this.infoTarget.innerHTML = '';
      this.infoTarget.classList.add('d-none');
    }
  }
}
